const DEFAULT_FAVICON =
  window.globalConfig?.LOGO_THUMBNAIL || '/brand-assets/logo_thumbnail.svg';
const BADGED_FAVICON = '/brand-assets/logo_thumbnail_badge.svg';

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    favicon.href = BADGED_FAVICON;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href = DEFAULT_FAVICON;
      });
    }
  });
};
